import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { CommissionPayload, createCommission } from 'config/requests/comissions';
import { Commission } from 'types/embedded/commission';

type CreateCommissionParams = {
  data: CommissionPayload;
  targetStatus?: string;
};

type Options = Omit<UseMutationOptions<Commission, Error, CreateCommissionParams>, 'mutationFn'>;

export function useCreateCommission(options?: Options) {
  const { mutate, mutateAsync } = useMutation({
    mutationFn: ({ data, targetStatus }: { data: CommissionPayload; targetStatus?: string }) =>
      createCommission(data, targetStatus),
    ...options,
  });

  return { createCommission: mutate, createCommissionAsync: mutateAsync };
}
